export default {
  name: "Control",
  methods: {
    isVoiceControlAvailable() {
      const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      return iOS === false;
    }
  }
}
